"use client";

import { AppLink } from "@/lib/routing";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";
import { Card } from "@/components/ui/card";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <main className="not-found-page">
      <Card asChild className="rounded-xl">
        <section className="not-found-card">
          <p className="not-found-code">404</p>
          <h1>{t("notFound.title")}</h1>
          <p>{t("notFound.description")}</p>
          <Button asChild>
            <AppLink to="/">{t("notFound.home")}</AppLink>
          </Button>
        </section>
      </Card>
    </main>
  );
}
